import { render, staticRenderFns } from "./JobReminderCriterionForm.vue?vue&type=template&id=66ce257a&"
import script from "./JobReminderCriterionForm.vue?vue&type=script&lang=js&"
export * from "./JobReminderCriterionForm.vue?vue&type=script&lang=js&"
import style0 from "./JobReminderCriterionForm.vue?vue&type=style&index=0&id=66ce257a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports